import { getKeys } from './getKeys'

export const pbsTranslations = {
  TITLE_PREFERENCES: '{{variable}} Preferences',
  BE_AWARE:
    'Please be aware that turning on and off {{variable}} could affect your reports!',
  TITLE_BEHAVIOUR: 'Positive Behaviour'
}

export const pbsConstants = getKeys(pbsTranslations)
